import React from 'react'
import PropTypes from 'prop-types'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'

import lang from '@/lang'
import { TextInput } from '@/modules/base/components/inputs/index'
import { ButtonIconSquare } from '@/modules/base/components/buttons'

import CheckIcon from '@assets/images/icons/check.svg'

const PublisherForm = ({ data, onSubmit }) => {
  const classes = useStyles()
  const { publisherForm } = lang.marketplace

  const validationSchema = Yup.object({
    fullName: Yup.string().required(lang.emptyRequiredFieldsErrorMessage),
    street: Yup.string().required(lang.emptyRequiredFieldsErrorMessage),
    postcode: Yup.number().required(lang.emptyRequiredFieldsErrorMessage).typeError(publisherForm.postcodeValidationError),
    city: Yup.string().required(lang.emptyRequiredFieldsErrorMessage),
    email: Yup.string().email(lang.invalidEmailErrorMessage).required(lang.emptyRequiredFieldsErrorMessage),
    website: Yup.string().url(lang.invalidWebsiteMessage),
    agbUrl: Yup.string().url(lang.invalidWebsiteMessage),
  })

  return (
    <Formik
      initialValues={data}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      enableReinitialize={true}
    >
      <Form>
        <TextInput name="fullName" placeholder={publisherForm.fullName} useFormik className={classes.row} />
        <TextInput name="street" placeholder={publisherForm.street} useFormik className={classes.row} />
        <div className={clsx(classes.postcodeCity, classes.row)}>
          <TextInput name="postcode" placeholder={publisherForm.postcode} useFormik className={classes.postcode} />
          <TextInput name="city" placeholder={publisherForm.city} useFormik className={classes.city} />
        </div>
        <TextInput name="email" placeholder={publisherForm.email} useFormik className={classes.row} />
        <TextInput name="website" placeholder={publisherForm.website} useFormik className={classes.row} />
        <TextInput name="phone" placeholder={publisherForm.phone} useFormik className={classes.row} />
        <TextInput name="agbUrl" placeholder={publisherForm.agbUrl} useFormik className={classes.row} />
        <ButtonIconSquare
          label={lang.saveButtonLabel}
          icon={CheckIcon}
          type='submit'
          className={classes.row}
        />
      </Form>
    </Formik>
  )
}

const useStyles = makeStyles(theme => ({
  row: {
    marginBottom: 10,
  },
  postcodeCity: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  postcode: {
    marginRight: 5,
  },
  city: {
    marginLeft: 5,
  },
}))

PublisherForm.propTypes = {
  data: PropTypes.shape({
    fullName: PropTypes.string,
    street: PropTypes.string,
    postcode: PropTypes.string,
    city: PropTypes.string,
    email: PropTypes.string,
    website: PropTypes.string,
    phone: PropTypes.string,
    agbUrl: PropTypes.string,
  }),
  onSubmit: PropTypes.func.isRequired,
}

PublisherForm.defaultProps = {
  data: {
    fullName: '',
    street: '',
    postcode: '',
    city: '',
    email: '',
    website: '',
    phone: '',
    agbUrl: '',
  },
}

export default PublisherForm
